import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IResult } from '../../../httpClient/serverApi/types/IResponse';

export interface DeleteCredentialParams {
    luid: string;
    targetClass: string;
}

export class DeleteCredentialRequest extends Request<DeleteCredentialParams, IResult> {
  constructor(params: DeleteCredentialParams) {
    super('deleteCredential', params);
  }
}
